import React, { Component, Fragment } from "react";
import Markdown from "react-markdown";
import RemarkGFM from "remark-gfm";

import Modal from "react-bootstrap/Modal";

import UBXButton from "./../../ubx/button";

import * as DeDupContents from "./../../../const/deduplication/";
import DedupLoanApplicationText from "./../../../const/deduplication/loan-application.json";
import DedupText from "./../../../const/deduplication.json";

export default class DeDuplicationModal extends Component {
    _mounted = false;

    constructor(props) {
        super(props);

        this.state = {
            content: "",
            contentReady: false,
        };
    }

    componentWillUnmount() {
        this._mounted = false;
    }

    async componentDidMount() {
        this._mounted = true;

        await this.initialize();
    }

    async componentDidUpdate(prevProps) {
        if (this.props.dedupError !== prevProps.dedupError) {
            await this.initialize();
        }
    }

    async initialize() {
        const { action = false, dedupError = false } = this.props;

        if (action) {
            let contentSource = false;
            switch (action) {
                case "sign-up":
                    contentSource = DeDupContents["SignUp"];
                    break;
                case "loan-application":
                    contentSource = DeDupContents["LoanApplication"];
                    break;
                default:
                    contentSource = DeDupContents["Default"];
                    break;
            }

            if (contentSource) {
                const contentRaw = await fetch(contentSource);

                let content = await contentRaw.text();

                if (dedupError) {
                    const dedupContent = [];

                    dedupError.map((err) => {
                        return dedupContent.push(DedupLoanApplicationText[err]);
                    });

                    content = content.replace(`%content%`, dedupContent.join("\n"));
                }

                if (this._mounted) {
                    await this.setState({ content, contentReady: true });
                }
            }
        }
    }

    onClose(e) {
        const { onClose = false } = this.props;

        if (onClose) {
            onClose();
        }
    }

    onContentButtonClick(href) {
        const { onLogin = false, onClose = false, redirectToDashboard = false } = this.props;

        let result = false;
        if (href === "#user-login" && onLogin) {
            onLogin();
            result = true;
        }

        if (redirectToDashboard) {
            redirectToDashboard();
        }

        if (result && onClose) {
            onClose();
        }
    }

    renderContent() {
        const { action = false } = this.props;
        const { content, contentReady } = this.state;

        let renderedContent = "";
        if (contentReady) {
            renderedContent = (
                <Markdown
                    id={`dedup-content-${action}`}
                    className={`dedup-content`}
                    plugins={[RemarkGFM]}
                    escapeHtml={false}
                    linkTarget="_blank"
                    renderers={{ link: (props) => this.renderLink(props) }}
                >
                    {content}
                </Markdown>
            );
        }

        return (
            <Fragment>
                <Modal.Header closeButton closeLabel="Close De-Duplication Modal">
                    {/*<Modal.Title>&nbsp;</Modal.Title>*/}
                </Modal.Header>
                <Modal.Body>{renderedContent}</Modal.Body>
            </Fragment>
        );
    }

    renderLink(props) {
        const { node, children, ...linkProps } = props;

        const { href: linkHref } = linkProps;
        const [href, linkComponent = false] = linkHref.split(",");

        let renderedLink;
        switch (linkComponent) {
            case "UBXButton": {
                renderedLink = (
                    <UBXButton type="primary" block={true} onClick={(e) => this.onContentButtonClick(href)}>
                        {children}
                    </UBXButton>
                );
                break;
            }
            default:
                renderedLink = <a {...{ href, ...linkProps }}>{children}</a>;
        }

        return renderedLink;
    }

    renderLoading() {
        const { loading } = this.props;

        return (
            loading && (
                <Modal.Body>
                    <div className="dedup-loading">
                        <h2>{DedupText["LoadingHeader"]}</h2>
                        <img src="/blank.gif" alt="Loading..." />
                    </div>
                </Modal.Body>
            )
        );
    }

    render() {
        const { show = true } = this.props;

        return (
            <Modal show={show} id="dedup-modal" backdrop="static" centered onHide={(e) => this.onClose(e)}>
                {this.renderLoading() || this.renderContent()}
            </Modal>
        );
    }
}
